import React from "react";
import { Box } from "@mui/material";

/**
 * Ícones do composer (emoji, IA, anexo) na mesma linha do campo no mobile.
 * Compacto: sem faixa extra e sem o toggle Cliente/Anotação (isso fica no seletor de canal).
 */
const ComposerMobileToolbar = ({ children }) => {
  if (!children) return null;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexShrink: 0,
        gap: 0,
        "& .MuiIconButton-root": {
          p: 0.5,
          width: 32,
          height: 32,
        },
      }}
    >
      {children}
    </Box>
  );
};

export default ComposerMobileToolbar;
